var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg158Bluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.853,358.123L288.442,255.446L410.853,152.77c4.55-3.815,7.168-9.455,7.147-15.393 c-0.021-5.938-2.678-11.559-7.253-15.343l-142-117.446c-5.971-4.938-14.256-5.981-21.264-2.684C240.474,5.203,236,12.253,236,20 v191.459l-109.147-91.552c-8.463-7.1-21.077-5.992-28.176,2.471c-7.099,8.462-5.992,21.077,2.471,28.176L226.2,255.446 L101.147,360.339c-8.463,7.099-9.569,19.713-2.471,28.176c7.098,8.462,19.713,9.57,28.176,2.471L236,299.435V492 c0,7.764,4.493,14.826,11.525,18.115c2.705,1.266,5.597,1.885,8.472,1.885c4.599,0,9.153-1.586,12.82-4.647l76-63.451 c8.479-7.079,9.614-19.691,2.535-28.17c-7.08-8.48-19.691-9.615-28.17-2.535L276,449.248v-152.03l109.147,91.552 c3.746,3.143,8.307,4.678,12.842,4.678c5.709,0,11.378-2.432,15.334-7.148C420.422,377.837,419.315,365.222,410.853,358.123z  M276,62.496l90.75,75.059L276,213.674V62.496z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg158Bluetooth);
export default __webpack_public_path__ + "static/media/158-bluetooth.bd77119a810239047bce87b9a0401667.svg";
export { ForwardRef as ReactComponent };